export default {
  'region_selector_global_tips': '玩家登录国家及所属区域',
  'region_selector_global_message': '展示全部的去重用户数据。',
  'region_selector_global_no_data_text': '展示该游戏发行国家的全部去重用户数据。'
}